<div class="section-container">
  <div class="text-content">
    <h2>Faça parte do nosso time <br>e se torne um tubarão do mercado imobiliário</h2>
    <p>
      Preencha o formulário ao lado, realize os testes e encaminhe o seu currículo.
    </p>
  </div>
  <div class="form-container">
    <div class="cabecalho-chamada-texto">
      <h3>Inicie seu cadastro</h3>
      <p>É simples e rápido.</p>
    </div>
    <form [formGroup]="form" (ngSubmit)="enviar()">
      <div class="form-group">
        <label for="nome">Nome</label>
        <input type="text" id="nome" placeholder="Nome Completo" formControlName="nome" />
        <small class="error" *ngIf="submitted && f.nome.invalid">Nome é obrigatório.</small>
      </div>

      <div class="form-group">
        <label for="email">E-mail</label>
        <input type="email" id="email" placeholder="Coloque seu e-mail" formControlName="email" />
        <small class="error" *ngIf="submitted && f.email.errors?.['required']">E-mail é obrigatório.</small>
        <small class="error" *ngIf="submitted && f.email.errors?.['email']">E-mail inválido.</small>
      </div>

      <div class="form-group">
        <label for="telefone">Telefone</label>
        <input type="form-control" id="telefone" placeholder="Informe seu telefone" formControlName="telefone"
          mask="(00) 00000-0000" />
        <small class="error" *ngIf="submitted && f.nome.invalid">Telefone é obrigatório.</small>
      </div>
      <div class="form-group">
        <label for="vaga">Vaga</label>
        <select id="vaga" formControlName="vaga">
          <option value="">Escolha qual vaga se candidatar</option>
          <option value="Corretor">Corretor(a) de imóveis</option>
          <option value="Assessor">Assessor(a) de Locações</option>
          <option value="Agenciador">Agenciador(a)</option>
          <option value="Administrativo">Administrativo</option>
          <option value="Marketing">Marketing</option>
          <option value="Recepcionista">Recepcionista</option>
          <option value="Financeiro ">Financeiro</option>
        </select>
        <small class="error" *ngIf="submitted && f.nome.invalid">Vaga é obrigatório.</small>
      </div>
      <div class="form-group">
        <label for="curriculo">Currículo (PDF)</label>
        <div *ngIf="selectedFile"
          style="margin-top:0.5rem; margin-bottom:5px; font-size:0.9rem; color:black; max-height:45px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; width:100%;">
          {{ selectedFile.name }}
        </div>
        <div class="custom-file-upload">
          <button type="button" class="btn btn-secondary" style="max-height: 35px; min-width: 150px; text-align: center; font-size: 12px;" (click)="fileInput.click()">Escolher arquivo</button>
          <input type="file" id="curriculo" #fileInput (change)="onFileSelected($event)" accept=".pdf" hidden />
        </div>
        <small class="error" *ngIf="submitted && !selectedFile">Por favor, envie um arquivo PDF.</small>
      </div>

      <div class="buttons">
        <button type="submit" class="btn btn-primary" [disabled]="isLoading">
          <span *ngIf="isLoading" class="spinner"></span>
          <span *ngIf="!isLoading">Enviar</span>
          <span *ngIf="isLoading">Enviando...</span>
        </button>
      </div>
    </form>
  </div>
</div>

<section class="container-secoes">
  <!-- Primeira coluna (unificada) -->
  <div class="secao">
    <app-title title="Os tubarões do mercado imobiliário"></app-title>


    <div class="p-sobre">
      <p>
        Somos conhecidos como tubarões do mercado imobiliário por nossa abordagem audaciosa na busca pelas melhores
        oportunidades. Sempre em movimento, com voracidade e competência.
      </p>
    </div>

    <h4 class="p-sobre">Como reconhecemos nossos colaboradores?</h4>

    <div class="colaboradores-container">
      <ul class="colaboradores-list">
        <li class="colaboradores-item">
          <i class="fas fa-trophy icon"></i>
          <h3>Meritocracia</h3>
        </li>
        <li class="colaboradores-item">
          <i class="fas fa-chart-line icon"></i>
          <h3>Plano de Carreira</h3>
        </li>
        <li class="colaboradores-item">
          <i class="fas fa-star icon"></i>
          <h3>Programa Profissional Destaque</h3>
        </li>
      </ul>
    </div>
  </div>

  <!-- Segunda seção -->
  <div class="secao">
    <app-title title="Unicancian"></app-title>

    <p class="p-sobre">
      A Universidade Corporativa é uma plataforma para desenvolvimento contínuo dos nossos colaboradores, visando
      desenvolver seu máximo potencial.
    </p>

    <div class="logo-unicancian">
      <img src="../../assets/uni_cancian.png" alt="Logo Unicancian">
    </div>
  </div>
</section>



<section class="premiacoes">
  <app-title title="Premiações"></app-title>
  <div class="p-sobre">
    <p>
      Viagens nacionais e internacionais, bônus, prêmios especiais e experiências fazem parte da nossa cultura de
      reconhecimento.
    </p>
  </div>
<swiper-container 
  space-between="30" 
  loop="true" 
  slides-per-view="2" 
  pagination="true" 
  speed="600" 
  autoplay='{"delay": 2400, "disableOnInteraction": false}'
  breakpoints='{"768": {"slidesPerView": 2}, "0": {"slidesPerView": 1}}'
>
  <swiper-slide lazy="true">
    <img src="../../assets/trabalhe_conosco/01.webp" alt="Equipe colaborando em projeto no escritório" loading="lazy" />
  </swiper-slide>
  <swiper-slide lazy="true">
    <img src="../../assets/trabalhe_conosco/02.webp" alt="Ambiente moderno do escritório" loading="lazy" />
  </swiper-slide>
  <swiper-slide lazy="true"  class="taller-slide">
    <img src="../../assets/trabalhe_conosco/03.webp" alt="Reunião de equipe em sala de conferência" loading="lazy" />
  </swiper-slide>
  <swiper-slide lazy="true">
    <img src="../../assets/trabalhe_conosco/04.webp" alt="Colaboradores em evento corporativo" loading="lazy" />
  </swiper-slide>
  <swiper-slide lazy="true">
    <img src="../../assets/trabalhe_conosco/05.webp" alt="Espaço de trabalho com tecnologia avançada" loading="lazy" />
  </swiper-slide>
  <swiper-slide lazy="true">
    <img src="../../assets/trabalhe_conosco/06.webp" alt="Equipe celebrando conquista profissional" loading="lazy" />
  </swiper-slide>
</swiper-container>

</section>

<br/>